import { render, staticRenderFns } from "./PageSkeletonTwo.vue?vue&type=template&id=41444e2a&scoped=true"
import script from "./PageSkeletonTwo.vue?vue&type=script&lang=js"
export * from "./PageSkeletonTwo.vue?vue&type=script&lang=js"
import style0 from "./PageSkeletonTwo.vue?vue&type=style&index=0&id=41444e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41444e2a",
  null
  
)

export default component.exports